module.exports = __webpack_public_path__ + "static/partners-list-962b37594805926b97e15f1d4d82c0c1.png";